import { ThunkDispatch, ThunkAction } from "redux-thunk";
import { IBooking, IBookingUpdateEvent, WebsocketMessageType } from "@vmosolutions/oc-interfaces";
import { IRootState } from "../../reducers/CombinedReducers";
import { AnyAction } from "redux";
import { Type } from "./CrewTravel.Actions";

const findBooking = (id: string) => (booking: IBooking) => booking._id === id;

/**
 * use a websocket action with Thunk to update the redux store
 * for bookings
 * @param updatedEvent -
 * @param actionType -
 */
export const websocketUpdatedBooking = (
  updatedEvent: IBookingUpdateEvent,
  actionType: WebsocketMessageType
): ThunkAction<void, IRootState, object, AnyAction> => {
  return (dispatch: ThunkDispatch<IRootState, object, AnyAction>, getState: () => IRootState): void => {
    if (!updatedEvent) {
      return;
    }
    const { oldEvent, newEvent } = updatedEvent;
    const currentBookings: IBooking[] = [...getState().crewTravel.bookings];
    const updatedBookings = updateBookings(currentBookings, oldEvent, newEvent);

    dispatch({
      type: Type.GOT_BOOKINGS,
      bookings: [...updatedBookings],
    });
  };
};

/**
 * Uses incoming booking events to determine if they should be added, removed or edited.
 * @param currentBookings -
 * @param oldEvent -
 * @param newEvent -
 */
const updateBookings = (
  currentBookings: IBooking[],
  oldEvent: IBooking | null,
  newEvent: IBooking | null
): IBooking[] => {
  // const lastModified = Date.now();
  const oldBookingIndex = currentBookings.findIndex(findBooking(oldEvent?._id));
  switch (true) {
    case oldBookingIndex >= 0 && !!newEvent: // EDIT
      //console.log("EDIT BOOKING", newEvent);
      currentBookings[oldBookingIndex] = newEvent;
      break;
    case oldBookingIndex >= 0 && !newEvent: // REMOVE
      //console.log("REMOVE BOOKING");
      currentBookings.splice(oldBookingIndex, 1);
      break;
    case oldBookingIndex === -1 && !!newEvent: // ADD
      //console.log("ADD BOOKING", newEvent);
      currentBookings.push(newEvent);
      break;
    default:
    // code block
  }
  return currentBookings;
};
